import React from 'react';
import { cn } from '../../utils/cn';
import { LoadingSpinner } from './LoadingSpinner';

export interface FormLoadingStateProps {
  isLoading: boolean;
  loadingText?: string;
  children: React.ReactNode;
  className?: string;
}

export const FormLoadingState: React.FC<FormLoadingStateProps> = ({
  isLoading,
  loadingText = 'Processing...',
  children,
  className
}) => {
  if (isLoading) {
    return (
      <div className={cn(
        'flex items-center justify-center gap-2 py-4',
        className
      )}>
        <LoadingSpinner size="sm" />
        <span className="text-sm text-muted-foreground">
          {loadingText}
        </span>
      </div>
    );
  }

  return <>{children}</>;
};